import React from 'react';
import css from './SectionMinimumAge.css';
import ScoreBadge from '../../../../components/ScoreBadge/ScoreBadge';
import { EditComponent } from '..';
import { IconCalendarL } from '../../../../icons';
import { Button } from '../../../../components';

export default ({
    publicData,
    isOwnListing,
    editParams,
    scoreData,
    authorDisplayName,
    isLoggedOut,
    isDraftVariant,
}) => {
    const { minimumAge } = publicData;
    const noData = !minimumAge;

    if (isLoggedOut && noData) return null;

    const showNoDataForLoggedInViewer =
        (isDraftVariant || (!isOwnListing && !isLoggedOut)) && noData;
    const showScoreData = !noData && scoreData;
    const showAddNewItemButton = !isDraftVariant && isOwnListing && noData;
    const editAllowed = !isDraftVariant && !noData && isOwnListing;

    const dataAvailable = !noData && (
        <p className={css.sectionMinAge}>
            <IconCalendarL />
            {minimumAge} Jahre
        </p>
    );

    const placeholderForLoggedInViewer = showNoDataForLoggedInViewer && (
        <p>{authorDisplayName} hat kein Mindestalter hinzugefügt.</p>
    );

    const content = dataAvailable || placeholderForLoggedInViewer;

    return (
        <div className={css.root}>
            {showScoreData && (
                <div className={css.matchingContainer}>
                    <ScoreBadge scoreData={scoreData.baseScoreBreakdown?.minimumAgeScore} />
                </div>
            )}
            <h2 className={css.sectionTitle}>
                <span>Mindestalter</span>
                {editAllowed ? (
                    <EditComponent pageName="experience" editParams={editParams} hideText={true} />
                ) : null}
            </h2>
            <div>{content}</div>
            {showAddNewItemButton && (
                <EditComponent
                    pageName="experience"
                    editParams={editParams}
                    rootClassName={css.addNewItemButton}
                >
                    <Button>Mindestalter hinzufügen</Button>
                </EditComponent>
            )}
        </div>
    );
};
